import styled from "styled-components";
import { Paper } from "@mui/material";

import Menu from "./sidebar components/Menu";

// Updated wrapper with softer padding and better box-shadow
const Wrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  gap: 12px;
  transition: width 0.2s ease;
  overflow: hidden;
  border-radius: 0;
  box-shadow: 5px 0 8px -6px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
`;

export default function Sidebar({
  sidebarState,
  onMouseEnter,
  onMouseLeave,
  selectedMenu,
  setSelectedMenu,
}) {
  return (
    <Wrapper
      elevation={0}
      style={{
        width: sidebarState.open ? "250px" : "80px",
      }}
    >
      {/* <IconDiv>
        {sidebarState.open && (
          <ImageDiv
            onClick={() => {
              const isAdminBrand = dashboardPermissions.some(
                (page) => page.ID === "administrator-brands"
              );

              const path = isAdminBrand
                ? pages.accountVerification.route
                : pages.brandDetails.route;

              navigate(path);
              setSelectedMenu(path);
            }}
          >
            <Image src={uiDetails.siteLogo} alt="Logo" />
          </ImageDiv>
        )}
      </IconDiv> */}

      <Menu
        sidebarState={sidebarState}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </Wrapper>
  );
}
